<template>
  <div class="components-layout nhylfzjc pd0">
    <div class="picture">
      <img :src="picture" />
    </div>
    <div class="pdf">
      <Pdf :url="url"></Pdf>
    </div>
  </div>
</template>

<script>
import Pdf from "@/components/common/Pdf.vue";
export default {
  components: { Pdf },
  data() {
    return {
      picture: "/images/jincheng.png",
      url: "/pdf/nhjc.pdf",
    };
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="less">
.nhylfzjc {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .picture {
    height: 855px;
    img {
      .setImg(contain);
    }
  }
  .pdf {
    width: 100%;
    height: 2150px;
  }
}
</style>
